import {
    createAsyncThunk,
    createSlice,
    PayloadAction,
} from "@reduxjs/toolkit";
import * as customerService from "../../../services/customerService";
import {
    CustomerListItemDto,
} from "../../../models/common/customer";
import { RootState } from "../store";

export interface CustomerState {
    customers: CustomerListItemDto[];
}

const initialState: CustomerState = {
    customers: null,
};

export const customerSlice = createSlice({
    name: "customer",
    initialState,
    reducers: {
        setCustomers: (
            state,
            action: PayloadAction<CustomerListItemDto[]>
        ) => {
            state.customers = action.payload;
        }
    },
});

export const { setCustomers } = customerSlice.actions;

export const getCustomers = createAsyncThunk(
    "customers/list",
    async(_, thunkApi) => {
        const res = await customerService.getCustomers(thunkApi.signal);
        thunkApi.dispatch(setCustomers(res.data));
    }
);

export const customerReducer = customerSlice.reducer;

export const selectCustomers = (state: RootState) : CustomerListItemDto[] => state.customer.customers;
